// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../sharedmodules/actions-list';
import { getDuplicatePinPlate } from '../repositories';

export const readDuplicatePinPlate = (getAccessToken) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const status = ['PENDING'];
        const duplicatePinPlatePaylod =
                { status };

        const duplicatePinPlateChanges =
        await getDuplicatePinPlate(getAccessToken, duplicatePinPlatePaylod);

        dispatch({
            data: duplicatePinPlateChanges,
            type: actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE,
        });

    } catch (error) {
    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};
